import React from 'react';
import { MpTextField } from '../../../../components';
import { useTranslation } from '../../../../hooks';

interface IProps {
    label?: string;
    value: string;
    onChange: (e: React.ChangeEvent<any>) => void;
}

const FromTextField = (props: IProps) => {
    const { label, value, onChange } = props;
    const { tc } = useTranslation();

    return (
        <MpTextField
            label={label || tc('phInputField', { fieldName: tc('from') })}
            value={value}
            onChange={onChange}
        />
    );
};

export default FromTextField;
